import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
    MessagePropType,
    Colours,
    Sizes,
    Select,
    HiddenField,
    useForm,
} from '@ratehub/base-ui';


function InlineScenarioSelect({ name, label, options, initialValue, onChange, className, ...otherProps }) {
    const form = useForm();

    function handleOnChange(value) {
        if (form && name) {
            form.setValue(name, value);
        }

        onChange?.(value);
    }

    return (
        <label className={className}>
            <p className="rh-title-l label">
                {label}
            </p>

            <If condition={form && name}>
                <HiddenField
                    name={name}
                    value={initialValue}
                />
            </If>

            <div className="scenarioOptions">
                <Select
                    name="scenarioOptions"
                    options={options}
                    value={form.values[name] ?? initialValue}
                    onChange={handleOnChange}
                    type="dropdown"
                    {...otherProps}
                />
            </div>
        </label>
    );
}

InlineScenarioSelect.propTypes = {
    name: PropTypes.string,
    label: MessagePropType.isRequired,
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
    initialValue: PropTypes.any,
    onChange: PropTypes.func,
};

InlineScenarioSelect.defaultProps = {
    name: undefined,
    initialValue: undefined,
    className: undefined,
    onChange: undefined,
};

const StyledInlineScenarioSelect = styled(observer(InlineScenarioSelect))`
    display: flex;
    align-items: center;
    margin-bottom: ${Sizes.SPACING.TWO};
    > .label {
        flex: 1;
        color: ${Colours.BLUEBERRY_DARK};
        margin: 0 ${Sizes.SPACING.TWO} 0 0;
    }
    > .scenarioOptions {
        flex: 1;
    }
`;

export default StyledInlineScenarioSelect;